import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import api from '../Utils/Axios';
import { API_BASE } from '../config/apiBase';
import Seo from '../Components/Seo';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.email || !formData.password) {
      const msg = "Email and password are required.";
      setError(msg);
      alert(msg);
      return;
    }

    try {
      setLoading(true);
      const response = await api.post("/api/auth/login", {
        email: formData.email,
        password: formData.password,
      });

      if (response.status === 200) {
        if (response.data?.token) localStorage.setItem("token", response.data.token);
        if (response.data?.user) localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("qtech_auth_api_base", API_BASE);
        if (typeof window !== "undefined") {
          window.dispatchEvent(new Event("qtech-auth-changed"));
        }
        alert(response.data?.message || "Login successful");
        const role = String(response.data?.user?.role || "").toUpperCase();
        const destination =
          role === "AGENT" || role === "ADMIN" ? "/agent-dashboard" : "/";
        navigate(destination);
        return;
      }

      const msg = "Login failed";
      setError(msg);
      alert(msg);
    } catch (err) {
      const msg = err?.response?.data?.message || "Login failed";
      setError(msg);
      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Seo title="Login | QTECH" description="QTECH account login." path="/login" noindex />
      <div className="ltn__login-area pb-65">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="section-title-area text-center">
          <h1 className="section-title">
            Sign In <br />
            To Your Account
          </h1>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. <br />
            Sit aliquid, Non distinctio vel iste.
          </p>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-6">
        <div className="account-login-inner">
          <form onSubmit={handleLogin} className="ltn__form-box contact-form-box">
            <input type="text" name="email" placeholder="Email*" value={formData.email} onChange={handleChange} />
            <input type="password" name="password" placeholder="Password*" value={formData.password} onChange={handleChange} />
            {error ? <p style={{ color: "#dc3545", marginBottom: "10px" }}>{error}</p> : null}
            <div className="btn-wrapper mt-0">
              <button className="theme-btn-1 btn btn-block" type="submit" disabled={loading}>
                {loading ? "SIGNING IN..." : "SIGN IN"}
              </button>
            </div>
            <div className="go-to-btn mt-20">
              <a
                href="#"
                title="Forgot Password?"
                data-bs-toggle="modal"
                data-bs-target="#ltn_forget_password_modal"
              >
                <small>FORGOTTEN YOUR PASSWORD?</small>
              </a>
            </div>
          </form>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="account-create text-center pt-50">
          <h4>DON'T HAVE AN ACCOUNT?</h4>
          <p>
            Add items to your wishlistget personalised recommendations <br />
            check out more quickly track your orders register
          </p>
          <div className="btn-wrapper">
            <Link to="/register" className="theme-btn-1 btn black-btn">
              CREATE ACCOUNT
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
  )
}

export default Login
